<script lang="ts" setup>
import type { ThemeColors } from '/#/common/theme'
import type { NotificationProps, NotificationType } from '/#/components/base/notification'

import { Notifications } from '@kyvg/vue3-notification'
import get from 'lodash-es/get'

import { isEmpty } from '/@/utils/is'

const { t } = useI18n()

const props = defineProps<NotificationProps>()

const notificationIconMap = {
  error: 'delete-disabled',
  warn: 'warning-essential',
  success: 'done-check',
  info: 'info-information',
}

const notificationButtonColorMap = {
  error: 'danger',
  warn: 'warning',
  success: 'success',
  info: 'info',
}

function getIsInline(props: Recordable) {
  return get(props.item.data, 'inline')
}

function getTimestamp(props: Recordable) {
  return get(props.item.data, 'timestamp')
}

function getTitle(props: Recordable) {
  return get(props.item.data, 'title')
}

function getMessage(props: Recordable) {
  return get(props.item.data, 'message', props.item.text)
}

function getButtons(props: Recordable) {
  return get(props.item.data, 'buttons')
}

function getButtonPosition(props: Recordable) {
  return get(props.item.data, 'buttonPosition', 'end')
}
</script>

<template>
  <Notifications
    v-bind="props"
    :group="group"
    pause-on-hover
    position="bottom right"
    width="20rem"
  >
    <!-- eslint-disable-next-line vue/no-template-shadow -->
    <template #body="props">
      <div
        class="notification"
        :class="[{ inline: getIsInline(props) }, props.item.type]"
      >
        <div class="notification-icon">
          <Icon
            :name="get(notificationIconMap, props.item.type as string, 'delete-disabled')"
            color="inherit"
          />
        </div>
        <div class="notification-body">
          <p class="notification-title">
            {{ getTitle(props) || t(`notification.${props.item.type}.title`) }}
          </p>
          <template v-if="!getIsInline(props)">
            <p
              class="notification-text"
             
              v-html="getMessage(props)"
            />
            <p
              v-if="getTimestamp(props)"
              class="notification-timestamp"
             
            >
              {{ getTimestamp(props) }}
            </p>
          </template>
          <div
            v-if="!isEmpty(getButtons(props))"
            class="notification-actions"
            :class="[getButtonPosition(props)]"
          >
            <Button
              v-if="get(props.item.data, 'cancelable')"
              color="slate"
              size="sm"
              variant="outlined"
              :text="t('action.cancel')"
              class="notification-cancel"
             
              @click="props.close"
            />
            <Button
              v-for="action in getButtons(props)"
              :key="action.text"
             
              size="sm"
              :color="
                notificationButtonColorMap[
                  props.item.type as NotificationType
                ] as ThemeColors
              "
              v-bind="action.props"
              v-on="action.emits"
            />
          </div>
        </div>

        <div class="notification-close-button">
          <Icon name="close" @click="props.close" />
        </div>
      </div>
    </template>
  </Notifications>
</template>
